import Modal from "../../modal/Modal";

function AlreadyExistsPopup({
  visible,
  onClose,
  getTranslateText,
  defaultMessage,
}) {
  if (!visible) return null;

  const getTextByKey = (key, fallback) => {
    console.log(getTranslateText, "Translate trans");
    const item = getTranslateText?.data?.find((item) => item.pageKey === key);
    return item?.keyValue || fallback;
  };

  return (
    <Modal visible={visible}>
      <div className=" w-4/8 m-auto ">
        <div className=""></div>
        <div className="bg-[#fff] px-6 py-6 rounded-[30px] flex flex-col justify-center items-center">
          <img src="../Images/confirm-icon.svg" alt="ConfirmImage" />
          <h5 className="font-semibold text-[18px] my-2">{"Alert..!"}</h5>
          <h3 className="text-[#808080] text-[14px]">
            {getTextByKey("user_already_exist_other_usertype", defaultMessage)}
          </h3>

          <div className="flex justify-around w-[100%]">
            <button
              onClick={onClose}
              className="bg-gradient-to-r from-[#2C3EA2] to-[#192867] text-[#fff] px-[50px] py-[10px] rounded-[10px] mt-[20px] text-center flex flex-row justify-center"
            >
              {getTextByKey("key_close", "Close")}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
}
export default AlreadyExistsPopup;
